import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Col, Modal, Table, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  fetchLabelSummary,
  fetchLabelProjects,
} from "../../store/actions/projects/projects.action";
import "./LabelSummary.css";

const LabelSummary = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(null);

  const { labelSummary, labelProjects } = useSelector((state) => state.projects);
  const { labels, totalLabeledProjects, loading } = labelSummary;
  const { projects, loading: projectsLoading } = labelProjects;

  useEffect(() => {
    dispatch(fetchLabelSummary());
  }, [dispatch]);

  const handleLabelClick = (label) => {
    if (label.count === 0) return;

    setSelectedLabel(label);
    setShowModal(true);
    dispatch(fetchLabelProjects(label.color));
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedLabel(null);
  };

  const handleProjectClick = (urlSlug) => {
    handleCloseModal();
    navigate(`/project_board/${urlSlug}`);
  };

  const getCapsuleTextColor = (color) =>
    ["yellow", "teal"].includes(color) ? "#333" : "#fff";

  const formatProjectDate = (date) => {
    if (!date) return "-";
    const dateLocal = new Date(date).toLocaleDateString("en-US").split("/");
    let month = parseInt(dateLocal[0], 10);
    let day = parseInt(dateLocal[1], 10);
    const year = dateLocal[2];

    day = day < 10 ? `0${day}` : day;
    month = month < 10 ? `0${month}` : month;
    return `${month}/${day}/${year}`;
  };

  if (loading) {
    return (
      <div className="label-summary-loading">
        <Spinner animation="border" size="sm" /> Loading labels...
      </div>
    );
  }

  if (totalLabeledProjects === 0) {
    return null;
  }

  return (
    <>
      <Row className="my-4">
        <Col>
          <h2 className="text-start fw-bolder mb-3">My Project Tags</h2>
          <div className="label-summary-container">
            {labels.filter((label) => label.count > 0).map((label) => {
              const textColor = getCapsuleTextColor(label.color);
              const isDarkText = textColor === "#333";

              return (
                <button
                  key={label.color}
                  type="button"
                  className={`label-summary-capsule ${
                    label.count === 0 ? "empty" : "clickable"
                  } ${isDarkText ? "text-dark" : "text-light"}`}
                  onClick={() => handleLabelClick(label)}
                  disabled={label.count === 0}
                  style={{
                    backgroundColor: label.rgb,
                    color: textColor,
                  }}
                >
                  <span className="label-name">{label.name}</span>
                  <span className="label-count">{label.count}</span>
                </button>
              );
            })}
          </div>
        </Col>
      </Row>

      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header
          closeButton
          style={{ borderBottom: `3px solid ${selectedLabel?.rgb}` }}
        >
          <Modal.Title>
            <span
              className="label-color-dot me-2"
              style={{ backgroundColor: selectedLabel?.rgb }}
            />
            {selectedLabel?.name} ({selectedLabel?.count} projects)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {projectsLoading ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
              <p className="mt-2">Loading projects...</p>
            </div>
          ) : projects.length > 0 ? (
            <Table hover responsive>
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>GC</th>
                  <th>Last Contact Date</th>
                  <th>Last Visit Date</th>
                </tr>
              </thead>
              <tbody>
                {projects.map((project) => (
                  <tr
                    key={project.id}
                    className="project-row"
                    onClick={() => handleProjectClick(project.url_slug)}
                  >
                    <td>
                      <Link
                        to={`/project_board/${project.url_slug}`}
                        className="text-decoration-none"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {project.name}
                      </Link>
                    </td>
                    <td>{project.account_name || "-"}</td>
                    <td>{formatProjectDate(project.last_contact_date)}</td>
                    <td>{formatProjectDate(project.last_visit_date)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div className="text-center py-4 text-muted">
              No projects found with this label.
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LabelSummary;
